import * as TYPES from '../types';

const initialState = {
    bannerList: [],
};

export function BannerReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_BANNERS_SUCCESS:
            return {
                ...preState,
                bannerList: payload,
            };

        default:
            return state;
    }
}